import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, FileWarning } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSuperUserDebugSessionDetail } from '@/hooks/useSuperUserDebugSessionDetail.ts';
import SessionMetadataCard from '@/components/superuser/SessionMetadataCard';
import BriefingPanel from '@/components/superuser/BriefingPanel';
import DynamicVariablesPanel from '@/components/superuser/DynamicVariablesPanel';
import DocumentsPanel from '@/components/superuser/DocumentsPanel';

export default function SuperUserDebugSessionDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useSuperUserDebugSessionDetail(id);

  return (
    <div className="space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate(-1)} className="-ml-2">
        <ChevronLeft className="mr-1 size-4" />
        {t('superuser.debug.detail.back', 'Volver al listado')}
      </Button>

      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('superuser.debug.detail.title', 'Detalle de sesión')}
        </h1>
        <p className="font-mono text-xs text-muted-foreground">{id}</p>
      </header>

      {error && (
        <div className="flex items-center gap-2 rounded-md border border-destructive/40 bg-destructive/10 p-4 text-sm text-destructive">
          <FileWarning className="size-4" />
          {error}
        </div>
      )}

      {isLoading && !data && (
        <div className="rounded-md border bg-card p-8 text-center text-sm text-muted-foreground">
          {t('superuser.debug.detail.loading', 'Cargando detalle…')}
        </div>
      )}

      {data && (
        <div className="space-y-4">
          <SessionMetadataCard session={data.session} />
          <BriefingPanel briefing={data.generatedBriefing} />
          <DynamicVariablesPanel variables={data.dynamicVariables} />
          <DocumentsPanel documents={data.documents} />
        </div>
      )}
    </div>
  );
}
